export function isTimeMachineReport (report) {
  return !!report && report.event === 'timeMachine'
}

export function getMineReportDisplayMeta (report) {
  if (isTimeMachineReport(report)) {
    return {
      tag: 'TimeMachine',
      category: 'Time Machine'
    }
  }
  return {
    tag: 'Reporting',
    category: 'Reporting Heatmaps'
  }
}
